module.exports = __webpack_public_path__ + "media/img/description/description-manual-after-efcf2bb4e61ddf5aef195f01d2129a29.svg";